import React from "react";
// REDUX
import { useSelector } from "react-redux";
// COMPONENTS
import AdaptersHeader from "./AdaptersHeader";
import AdapterEditorDrawer from "../../components/adapters/AdapterEditorDrawer";
import AdaptersDeleteModal from "./AdaptersDeleteModal";
import AdaptersDrawer from "./AdaptersDrawer";
import AdaptersTable from "./AdaptersTable";
import KeysAssignInterface from "../keys/KeysAssignInterfaceAdapter";
// AUTHORIZATION
import { useScreenPermission } from "../../../customHooks/useScopedPermission";
import UnauthorizedPage from "../../unauthorized/UnauthorizedPage";
// INTERFACES
import { RootState } from "../../../app/store";

function AdaptersPage() {
  // GLOBAL VARIABLES ******************************* */

  // ************************************************ */
  // USE STATE VARIABLES **************************** */

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */
  const { theme } = useSelector((state: RootState) => state.home);
  // Reads SCREEN_PERMISSION["adapters"] -- the same declaration Layout.tsx's
  // sidebar link reads.
  const allowed = useScreenPermission("adapters");

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */

  // ************************************************* */
  // USE EFFECT ************************************** */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div>
      {allowed ? (
        <div className={`layout__contentPage__${theme}`}>
          <AdaptersHeader />
          <AdaptersTable />
          <AdapterEditorDrawer />
          <AdaptersDeleteModal />
          <AdaptersDrawer />
          <KeysAssignInterface />
        </div>
      ) : (
        <UnauthorizedPage />
      )}
    </div>
  );
}

export default AdaptersPage;
